import "./ButtonBox_s.css";

const ButtonBox_s = ({ children }) => {
    return <div className="buttonBox_s">{children}</div>;
};

export default ButtonBox_s;